/* src/app/home-new/home-settings-section/home-settings-section.component.scss */
.settings_selectorButton {
  margin: 0;
  z-index: 1;
}
.settings_selectorButton ion-icon {
  font-size: 28px;
  fill: #949494;
  transition: fill 0.3s ease-in-out;
}
.settings_selectorButton ion-label {
  color: #949494;
  text-align: center;
  font-family: "Barlow Semi Condensed", sans-serif;
  font-size: 24px;
  font-weight: 500;
  transition: color 0.3s ease-in-out;
}
.settings_selectorButton.selected ion-icon {
  fill: var(--color);
}
.settings_selectorButton.selected ion-label {
  color: var(--color);
}
.settings_selectorButton.selected.selected-general {
  --color: #259dff;
}
.settings_selectorButton.selected.selected-finishing {
  --color: #f5b200;
}
.settings_content {
  padding: 0px 0px 0px 20px;
  background-color: #f6f6f6;
}
.settings_hideButton {
  position: absolute;
  top: 50%;
  left: 100%;
  transform: translate(-6px, -50%);
  cursor: pointer;
  z-index: 9;
}
.settings_hideButton div {
  width: 30px;
  height: 120px;
  position: relative;
}
.settings_hideButton #settings_hideButton_shape {
  position: absolute;
  width: 100%;
  height: 100%;
}
.settings_hideButton #settings_hideButton_arrow {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-65%, -50%);
  transition: transform 0.5s ease-in-out;
}
.settings_hideButton #settings_hideButton_arrow.collapsed {
  transform: translate(-50%, -50%) rotateY(180deg);
}
@media (max-width: 1104px) {
  .settings_hideButton {
    display: none;
  }
}
.settings_selectorButtonContainer {
  height: 90px;
  padding: 10px 20px;
  background: #f6f6f6;
}
.settings_selectorButtonContainer .settings_selectorButtonInnerContainer {
  --padding-selector: 10px;
  padding: var(--padding-selector);
  position: relative;
  border-radius: 100px;
  background: var(--Blanco-y-negro-BLANCO, #f6f6f6) !important;
  border: 1px solid var(--Blanco-y-negro-GRIS-3, #949494);
}
.settings_selectorButtonContainer .settings_selectorButtonInnerContainer .selector_mark {
  position: absolute;
  height: 75%;
  width: 47%;
  top: 50%;
  border-radius: 100px;
  transform: translate(0, -50%);
  transition: all 0.3s ease-in-out;
}
.settings_selectorButtonContainer .settings_selectorButtonInnerContainer .selector_mark.selected-general {
  border: 1px solid var(--Colores-secundarios-CIAN-OSCURO, #259dff);
  background: var(--Colores-secundarios-CIAN-CLARO, #d4ecff);
  left: 3%;
}
.settings_selectorButtonContainer .settings_selectorButtonInnerContainer .selector_mark.selected-finishing {
  border: 2px solid var(--Colores-secundarios-AMARILLO-OSCURO, #d59b00);
  background: var(--Colores-secundarios-AMARILLO-CLARO, #fff0c6);
  left: 50%;
}
.disabled * {
  pointer-events: none;
}
.settings-config-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 16px;
  width: 100%;
  color: #f6f6f6;
  background-color: #f6f6f6;
}
.settings-config-title-text {
  color: var(--Blanco-y-negro-NEGRO-TEXTO, #000);
  text-align: center;
  font-family: var(--fontFamily-Barlow-Semi-Condensed, "Barlow Semi Condensed");
  font-size: var(--fontSize-22, 22px);
  font-weight: var(--fontWeight-medium, 500);
  line-height: normal;
}
.close-icon {
  display: none;
  align-items: center;
  cursor: pointer;
  flex-shrink: 0;
}
.close-icon img {
  width: 24px;
  height: 24px;
  color: var(--Blanco-y-negro-NEGRO-TEXTO, #000);
}
@media (max-width: 767px) {
  .close-icon {
    display: flex !important;
  }
}
/*# sourceMappingURL=home-settings-section.component-OUEARCXT.css.map */
